import React, { useMemo } from "react";
import { Search, ChevronRight, X, FileText } from "lucide-react";

export default function TermsSidebar({
  sections = [],
  activeId = "",
  onSelectSection = () => {},
  searchQuery = "",
  setSearchQuery = () => {},
}) {
  const filteredSections = useMemo(() => {
    const q = (searchQuery || "").trim().toLowerCase();
    if (!q) return sections;
    return sections.filter(
      (sec) =>
        sec.tabTitle.toLowerCase().includes(q) ||
        sec.shortTitle?.toLowerCase().includes(q) ||
        sec.summary?.toLowerCase().includes(q)
    );
  }, [sections, searchQuery]);

  return (
    <aside
      className="terms-sidebar-card d-none d-lg-flex"
      aria-label="Terms of Service Sections"
    >
      <div className="terms-sidebar-header">
        <div className="d-flex align-items-center justify-content-between mb-1">
          <div className="d-flex align-items-center gap-2">
            <FileText size={18} className="text-primary" />
            <h2 className="h6 mb-0 fw-bold text-dark">Terms Navigation</h2>
          </div>
          <span className="badge bg-light text-dark border">
            {sections.length} Sections
          </span>
        </div>

        <div className="terms-sidebar-search">
          <Search size={14} className="terms-sidebar-search-icon" />
          <input
            type="text"
            className="form-control terms-sidebar-search-input"
            placeholder="Search terms sections..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            aria-label="Filter terms sections"
          />
          {searchQuery && (
            <button
              type="button"
              className="btn btn-sm btn-link text-muted position-absolute end-0 top-50 translate-middle-y p-0 me-2 text-decoration-none"
              onClick={() => setSearchQuery("")}
              aria-label="Clear search"
            >
              <X size={14} />
            </button>
          )}
        </div>
      </div>

      <nav
        className="terms-sidebar-list"
        role="tablist"
        aria-orientation="vertical"
      >
        {filteredSections.length === 0 ? (
          <div className="p-3 text-center text-muted small">
            No sections match &ldquo;{searchQuery}&rdquo;
          </div>
        ) : (
          filteredSections.map((section) => {
            const isActive = section.id === activeId;
            const originalIndex = sections.findIndex((s) => s.id === section.id) + 1;
            const formattedNum = String(originalIndex).padStart(2, "0");

            return (
              <button
                key={section.id}
                role="tab"
                id={`tab-${section.id}`}
                aria-controls={`panel-${section.id}`}
                aria-selected={isActive}
                type="button"
                className={`terms-nav-item ${
                  isActive ? "terms-nav-item--active" : ""
                }`}
                onClick={() => onSelectSection(section.id)}
              >
                <div className="d-flex align-items-center w-100 overflow-hidden">
                  <span className="terms-nav-num">{formattedNum}</span>
                  <span className="terms-nav-title">{section.tabTitle}</span>
                </div>
                <ChevronRight size={15} className="terms-nav-arrow" />
              </button>
            );
          })
        )}
      </nav>
    </aside>
  );
}

